
import { IStoreState } from "@montana/store/store";
import { generateContainer, IContainerProps } from "../base/generate-container";
import { ICartContainerState } from "./cart";
import {
    addCartLine,
    placeOrder,
    placeOrderError,
    placeOrderSuccess,
    resetOrderState,
    reinstateCartLine,
    updateCartLineQuantity,
    addVoucher,
    removeVoucher,
} from './cart.actions';


const mapState = ({ cart }: IStoreState): ICartContainerState => ({ ...cart });

const actions = {
    placeOrder,
    placeOrderError,
    placeOrderSuccess,
    addCartLine,
    updateCartLineQuantity,
    resetOrderState,
    reinstateCartLine,
    addVoucher,
    removeVoucher,
};

export type ICartContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof actions>;

export const [CartContainer, connectWithCart, useCart] = generateContainer(mapState, actions);
